import DOMPurify, { Config } from 'dompurify';

const validProjectUrls = [
  'http://professionalworks.demv.internal',
  'https://professionalworks.demv.internal',
  'https://mvp.professional.works',
  'https://dev.deutscher-maklerverbund.de',
];

export const isValidProjectUrlRegEx = new RegExp(
  `^(${validProjectUrls
    .map((url) => url.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'))
    .join('|')})`,
);

export const sanitize = (
  text: string,
  allowedTags?: string[],
  allowedTagAttributes?: string[],
  addUriExtraSafeAttributes?: string[],
  allowExternalUrls?: boolean,
) => {
  const config: Config = {};

  if (allowedTags) {
    config.ALLOWED_TAGS = allowedTags;

    if (allowedTags.includes('a') && allowExternalUrls !== true) {
      config.ALLOWED_URI_REGEXP = isValidProjectUrlRegEx;
    }
  }

  if (allowedTagAttributes) {
    config.ALLOWED_ATTR = allowedTagAttributes;
  }

  if (addUriExtraSafeAttributes) {
    config.ADD_ATTR = addUriExtraSafeAttributes;
    config.ADD_URI_SAFE_ATTR = addUriExtraSafeAttributes;
  }

  return DOMPurify.sanitize(text, config);
};

export const sanitizeStreetName = (street: string): string =>
  street.replace(/Stra[sß]+e/, 'Str.').replace(/stra[sß]+e/, 'str.');
